import { Button } from '@/design-system/button/button';
import { Stack } from '@/design-system/stack/stack';
import { BadgeCheck } from 'lucide-react';

type VerificationRequiredProps = {
  onBookACall: () => void;
};

export const VerificationRequired = ({ onBookACall }: VerificationRequiredProps) => {
  return (
    <Stack space={6} align="center">
      <Stack space={4} align="center">
        <div className="h-10 w-10 rounded-lg bg-muted p-2.5">
          <BadgeCheck className="h-full w-full text-foreground" />
        </div>

        <Stack space={2} align="center">
          <h2 className="text-center text-lg font-medium text-foreground">We need to verify your business</h2>

          <p className="text-center text-sm font-normal text-muted-foreground">
            Before we can open your treasury account, we need to collect some information about your company. Book a
            15-minute call with the team.
          </p>
        </Stack>
      </Stack>

      <Button variant="default" onClick={onBookACall}>
        Book a call
      </Button>
    </Stack>
  );
};
